import React from "react";
import { MdDelete } from "react-icons/md";
import { FaPlus } from "react-icons/fa";
import Modal from "../ui/Modal";
import Button from "../ui/Button";
import { Input } from "../ui/Field";

const ModalAddFish = ({ show, handleClose, data, setData, fishes, setFishes }) => {
  const addQtyPrice = () => {
    setData({ ...data, quantities: [...(data.quantities ?? []), { qty: "", price: "" }] });
  };

  const handleUpdateFields = (field, value, index) => {
    const updatedData = { ...data };
    if (index > -1) {
      updatedData.quantities[index][field] = value;
    } else {
      updatedData[field] = value;
    }
    setData(updatedData);
  };

  const handleDelete = (index) => {
    const updatedData = { ...data };
    updatedData.quantities.splice(index, 1);
    setData(updatedData);
  };

  const handleSaveItem = () => {
    const newItem = { ...data };
    if (data?.index > -1) {
      const updated = [...fishes];
      updated[data?.index] = newItem;
      setFishes(updated);
    } else {
      setFishes((prev) => [...prev, newItem]);
    }
    handleClose();
  };

  const deleteFish = () => {
    setFishes((prev) => prev.filter((_, i) => i !== data.index));
    handleClose();
  };

  return (
    <Modal
      open={!!show}
      onClose={handleClose}
      title="Προσθήκη Ψαριού"
      footer={
        <>
          <Button variant="secondary" onClick={handleClose}>
            Κλείσιμο
          </Button>
          {data.index > -1 && (
            <Button variant="danger" onClick={deleteFish}>
              Διαγραφή
            </Button>
          )}
          <Button onClick={handleSaveItem}>Αποθήκευση</Button>
        </>
      }
    >
      <div className="space-y-3 py-1">
        <Input label="Ψάρι" value={data?.name} onChange={(e) => handleUpdateFields("name", e.target.value)} />
        <Input
          label="Κιβώτια"
          inputMode="decimal"
          value={data?.kivotia}
          onChange={(e) => handleUpdateFields("kivotia", e.target.value.replace(",", ".")) || 0}
        />

        {data?.quantities?.length > 0 && <h4 className="pt-1 font-semibold text-brand-700">Πωλήσεις</h4>}
        {data?.quantities?.map((item, index) => (
          <div key={index} className="flex items-end gap-2">
            <Input
              label="Ποσ."
              inputMode="decimal"
              className="flex-1"
              value={item.qty}
              onChange={(e) => handleUpdateFields("qty", e.target.value.replace(",", ".") || 0, index)}
            />
            <Input
              label="Τιμή"
              inputMode="decimal"
              className="flex-1"
              value={item.price}
              onChange={(e) => handleUpdateFields("price", e.target.value.replace(",", ".") || 0, index)}
            />
            <button
              type="button"
              onClick={() => handleDelete(index)}
              className="mb-1.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-rose-500 hover:bg-rose-50"
              aria-label="Διαγραφή"
            >
              <MdDelete size={22} />
            </button>
          </div>
        ))}

        <Button variant="outline" className="w-full" onClick={addQtyPrice}>
          <FaPlus size={12} /> Προσθήκη Ποσότητας και Τιμής
        </Button>
      </div>
    </Modal>
  );
};

export default ModalAddFish;
